import { operatorClient } from 'domain/HttpClients';

export const fetch = (params = {}) => operatorClient
  .Get('/api/finance/credit-terms/invoices')
  .withParams(params)
  .send();

export const markAsPaid = (id) => operatorClient
  .Put('/api/finance/credit-terms/invoices')
  .withParams({ invoiceId: id })
  .send();
